<template xmlns:el-col="http://www.w3.org/1999/html">
  <div class="container">
    <h2 class="process-title">
      {{selfCheck ? "3. 自查后标注" : "1. 初标注"}}: 从下列选择与本例图 <span class="strong-text">相符的碗碟</span>, 并标记
      <div class="tag-wrapper">
        <el-badge :value=" imageMarkedCount" class="item">
          <el-tag type="success">已标记</el-tag>
        </el-badge>
        <el-badge :value="batchImageListUnmarked.length" class="item">
          <el-tag type="danger">未标记</el-tag>
        </el-badge>
        <el-badge :value="batchImageListDelete.length" class="item">
          <el-tag type="danger">已删除</el-tag>
        </el-badge>
      </div>
    </h2>
    <el-row :gutter="5" class="class-dish" type="flex">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>名称: {{currentDishModel.dish_name}}</span>
         <div class="btn-wrapper-1">
           <el-button type="primary" size="mini" :disabled="currentIndex < 1"  @click="preDishModel">上一个</el-button>
           <el-button type="primary" size="mini" :disabled="currentIndex === dishModelCount - 1"
                      @click="nextDishModel">下一个
           </el-button>
           <el-button type="danger" size="mini" @click="toSelfCheck">纠错</el-button>
           <el-button type="success" size="mini" @click="submitMarkedData">标注完成</el-button>
         </div>
        </div>
        <el-badge :value="batchImagesBlongCurrentModel.length" class="item">
          <img :src="currentDishModel.dish_image_url" width="150" alt="">
        </el-badge>
        <div class="image-wrapper">
          <div class="image-item" v-for="dish in batchImagesBlongCurrentModel" :key="dish.dish_uuid">
            <img  :src="dish.dish_img_url" alt="" width="50px" height="50px" >
          </div>
        </div>
      </el-card>
        <el-card class="box-delete">
          <div slot="header" class="clearfix">
            <span>已删除图片</span>
          </div>
          <div class="image-wrapper">
            <div class="image-item" v-for="dish in batchImageListDelete" :key="dish.dish_uuid">
              <el-popover
                ref="popover1"
                placement="top-start"
                trigger="hover"
                >
                <img :src="dish.dish_img_url" slot="reference" alt="" width="50px" height="50px" >
                <img :src="dish.dish_img_url"  alt="">
              </el-popover>
            </div>
          </div>
        </el-card>
      <div class="btn-wrapper">
        <!--<el-button type="primary" @click="saveLocal">保存</el-button>-->
      </div>
    </el-row>
    <imageMarkWrapper
      :images="batchImageListUnmarked"
      :current_class_id="currentDishModel.class_id"
    >
    </imageMarkWrapper>
  </div>
</template>
<script type="">
import {mapGetters, mapMutations} from 'vuex';
import imageMarkWrapper from '_c/imageMarkWrapper';
import {apiChangeBatchState, apiGetBatchImageList, apiMarkBatchImages, apiQueryCanteenClassList} from '@/api';

export default {
  name: 'markProcess',
  components: {
    imageMarkWrapper
  },
  data () {
    return {
      currentIndex: 0,
      modelList: []
    };
  },
  mounted () {
    this.getModelList();
    this.setSubTitle('图片标注');
    this.getImagesByBatchTag();
  },
  methods: {
    ...mapMutations([
      'changeCurrentDishModelIndex',
      'setBatchImageList',
      'setBatchTag',
      'setSubTitle'
    ]),
    async getModelList () {
      try {
        let res = await apiQueryCanteenClassList({ canteenId: this.canteen.canteen_id, apiKey: this.apiKey });
        console.log(res.dish_info_list);
        this.modelList = res.dish_info_list;
      } catch (e) {
        console.log(e);
      };
    },
    // 保存标记状态到本地
    saveLocal () {

    },
    toSelfCheck () {
      if (this.batchImageListUnmarked.length > 0) {
        this.$alert('标注还未完成, 请继续标注', '', {
          confirmButtonText: '确定'
        });
      } else {
        this.$router.push({
          path: '/dataMark/checkProcess',
          query: {
            batch_tag: this.batch_tag,
            selfCheck: true
          }
        });
      }
    },
    // 查询批次图片
    async getImagesByBatchTag () {
      if (this.selfCheck === true) {
        // 自查返回
      } else {
        let res = await apiGetBatchImageList({
          canteen_id: this.listQuery.canteen.canteen_id,
          batch: this.batch_tag,
          apiKey: this.apiKey
        });
        this.setBatchImageList(res);
      }
    },
    // 下一个例图
    nextDishModel () {
      if (this.currentIndex < this.modelList.length) {
        this.currentIndex++;
      }
    },
    // 上一个例图
    preDishModel () {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    async submitMarkedData () {
      if (this.batchImageListUnmarked.length > 0) {
        this.$alert('标注还未完成, 请继续标注', '', {
          confirmButtonText: '确定'
        });
      } else {
        await apiMarkBatchImages({
          apiKey: this.apiKey,
          canteen_id: this.canteen.canteen_id,
          label_info_list: this.markImageList,
          batch: this.batch_tag
        });
        await apiChangeBatchState({
          system_id: 1,
          batch_tag: this.batch_tag,
          batch_state: 2,
          apiKey: this.apiKey
        });
        this.setBatchTag('');
        this.$router.push('/dataMark/batchList');
      }
    }
  },
  computed: {
    ...mapGetters(['currentDishModelIndex', 'listQuery', 'userinfo']),
    selfCheck () {
      return this.$route.query.selfCheck || false;
    },
    canteen () {
      if (this.$route.query && this.$route.query.canteen) {
        return this.$route.query.canteen;
      } else {
        return this.listQuery.canteen;
      }
    },
    apiKey () {
      return this.$store.getters.userinfo().api_key;
    },
    markedCount () {
      return this.$store.state.markedCount[this.currentDishModel.class_id] || 0;
    },
    dishModelCount () {
      return this.modelList.length || 0;
    },
    currentDishModel () {
      return this.modelList[this.currentIndex];
    },
    markImageList () {
      return this.$store.getters.markImageList();
    },
    batch_tag () {
      return this.$store.getters.batchTag;
    },
    batchImageListUnmarked () {
      return this.markImageList.filter((image) => {
        return !image.class_id;
      });
    },
    batchImageListDelete () {
      return this.markImageList.filter((image) => {
        return image.class_id === '-1';
      });
    },
    batchImagesBlongCurrentModel () {
      return this.markImageList.filter((image) => {
        return image.class_id === this.currentDishModel.class_id;
      });
    },
    imageMarkedCount () {
      return -this.batchImageListUnmarked.length - this.batchImageListDelete.length + this.markImageList.length;
    }
  },
  watch: {
    currentDishModelIndex () {

    }
  }
};
</script>
<style  scoped lang="scss">
  .container {
    .process-title {
      .strong-text {
        color: #65c13e;
      }
      .tag-wrapper {
        padding-left: 10px;
        display: inline-block;
      }
    }
    .box-card {
      width: 70%;
      .btn-wrapper-1 {
        display: inline-block;
        margin-top: -10px;
        float: right;
      }
    }
    .image-wrapper {
      max-width: 70%;
      display: inline-block;
      vertical-align: top;
      .image-item {
        display: inline-block;
        margin: 5px;
      }
    };
  }

</style>
